import { Component, AfterViewInit, OnInit, OnDestroy, EventEmitter, Renderer2, ViewChild, HostListener, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isNil } from 'lodash-es';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Observable } from 'rxjs';
import { Store, ActionsSubject} from '@ngrx/store';
import { EnvironmentConfiguration } from './environment/services/environment.configuration';
import { SubSink } from 'subsink';
import * as models from './shared/model/api/AuthData';
import { SharedDataService } from './core/services/shared-data.service';
import { SharedFunctionService } from './core/services/shared-func.service';
import { Logger } from './core/services/logger';
import * as fromSelector from './core/state/selectors/index';
import { AppState } from './state/app.state';
import { filter } from 'rxjs/operators';
import { getPageDetails, PagesEnum } from './core/helpers/page-info';
import { AppNavBarSetNavigation, APP_NAVBAR_ACTION } from './core/state/actions/app-navbar.action';
import { CustomerDealSummary } from '../app/shared/model/api/CustomerDealSummary';
import { SUMMARY_ACTION } from './feature/writeups-leads/state/actions/summary.action';
import { AuthServiceForgerock } from './core/services/auth-service.service';
import { ofType } from '@ngrx/effects';
import { AutorizationService } from 'src/app/core/services/authorization-service';
import { Action } from '../assets/core';
import { ModalComponent }  from './core/components/general/modal/modal.component';
import { HEADER_MENU_ACTION, WriteupDetailOpenDialog } from './feature/writeups-detail/state/actions/writeup-detail-header.action';
import { MatDialogRef, MatDialog} from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import * as appDealerDetailActions from '../../src/app/core/state/actions/dealer-detail-auth.action';
 
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild('simulatorPdfViewer') public simulatorPdfViewer: ElementRef;
  @ViewChild('modal') public modal: ElementRef; 
  title = 'MST Console';
  clickoutHandler: Function;
  paymentSimulatorPdfFilename:string;
  paymentSimulatorPdfData:any = null;
  dialogRef: MatDialogRef<ModalComponent>;
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.clickoutHandler) {
      this.clickoutHandler(event);
    }
  }
  private readonly subs = new SubSink();
  public modalDialog: any;
  public alertDialog: any;
  public appMenuDialog: any;
  authData$: Observable<models.AuthData>;
  hasAccess = false;
  isUserTimedOut = false;
  loggedInUserName: string;
  get IsLoggedIn(): boolean {
    return !isNil(this.loggedInUserName);
  }
  get isAuthorizedUser (){
    return this.authService.isUserAuthorized();
  }
  dealNotificationData: CustomerDealSummary[];

  dealNotificationPendingApprovalCount = 0;

  chatNotificationCount = 0;

  globalNotificationCount = 0;
  paymentSimulatorMasterData = null;


  constructor(
    public route: ActivatedRoute,
    public router: Router,
    private readonly environment: EnvironmentConfiguration,
    private readonly _actionsSubject: ActionsSubject,
    public sharedDataService: SharedDataService,
    public sharedFuncService: SharedFunctionService,
    private readonly store: Store<AppState>,
    private readonly idle: Idle,
    private readonly logger: Logger,
    private readonly authService: AuthServiceForgerock,
    private readonly autorizationService: AutorizationService,
    private readonly renderer: Renderer2,
    private readonly http: HttpClient,
    public matDialog: MatDialog,
    private _store: Store<AppState>
  ) {
    try {
      this.modalDialog = {
        action: new Action({ onClick: new EventEmitter<any>() }),
        data:{},
        buttons: [],
        template: undefined,
        style: {}
      }
      this.authData$ = store.select(fromSelector.getAuthData);
      
      idle.setIdle(3300);
      idle.setTimeout(300);
      idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

      idle.onIdleEnd.subscribe(() => {
        this.isUserTimedOut = false;
      });
      idle.onTimeout.subscribe(() => {
      });
      idle.onTimeoutWarning.subscribe((countdown) => {
        if (this.isUserTimedOut === false) {
          this.isUserTimedOut = true;
        }
      });
      this.reset();
    } catch (error) {
      this.logger.error(error);
    }
  }
  ngOnInit() {
    try {
      this.authData$.subscribe(data => {
        if (!isNil(data?.user?.profile)) {
          const userProfile = data.user.profile;
          const userType = userProfile.user_type?.toLowerCase();

          if (userType === 'dealer-user') {
            data.user['dealerCode'] = userProfile.dealer_number;
          } else if (!isNil(userProfile.primary_dealer_number)) {
            data.user['dealerCode'] = userProfile.primary_dealer_number;
          }
        }

        this.getDealerName(data);
        this.getDealerPhone(data);
        this.setDealerPersonnelName(data);
        this.setDealerPersonnelFullName(data);
        this.setDealerPersonnelEmail(data);

        this._actionsSubject.pipe(ofType<any>(appDealerDetailActions.LoadDealerSuccessAction)).subscribe(responseData => {
          if (!isNil(this.sharedDataService) && !isNil(this.sharedDataService.dealerCode)) {
            this.store.dispatch(appDealerDetailActions.DealerConfigAction({ payload: this.sharedDataService.dealerCode }));
            if (data?.user !== null) {
              this.initializeNavbar(data);
            }
          }
        });
      });

      this.autorizationService.getBrand().subscribe(response => {
        if (!isNil(response)) {
          if (response === 'Lexus') {
            this.renderer.addClass(document.body, 'lexus-theme')
          } else if (response === 'Toyota') {
            this.removeLexusStylesheet()
            this.renderer.addClass(document.body, 'toyota-theme');
          }
          let providerID = 'Toyota';
          this.getPaymentSimulatorMasterData({ provider: providerID, isMasterData: "true" }).
            subscribe(masterData => {
              masterData['provider'] = response;
              this.paymentSimulatorMasterData = masterData;
              this.sharedDataService.getVehicleAttributesMasterData = masterData;
            })

          // for plate transfer UI visibility
          this.getPlateTransferUIStatus({ senderId: 'MST', isNew: "true" }).
            subscribe(response => {
              this.sharedDataService.plateTransferUIStatus = response;
            })
        }
      });


      this.subs.sink = this._actionsSubject
        .pipe(filter(action => action.type === APP_NAVBAR_ACTION.OPEN_DIALOG
          || action.type === SUMMARY_ACTION.OPEN_DIALOG
          || action.type === HEADER_MENU_ACTION.OPEN_DIALOG))
        .subscribe(data => {
          const payload = data['payload'];
          this.modalDialog.template = payload['template'];
          this.modalDialog.style = payload['style'] || {};
          this.modalDialog.data = payload['data'] || {};
          if (Object.keys(this.modalDialog.data).length > 0 && this.modalDialog.data.openModal) {
            this.modalDialog = { ...this.modalDialog };
            this.openModal();
          }
          this.modalDialog.action.onClick.emit();
        });
    } catch (error) {
      this.logger.error(error);
    }

    this.sharedDataService.regionCode.subscribe(code => {
      if (code !== '') {
        this.store.dispatch(appDealerDetailActions.LoadCreditAction({ payload: { regionCode: code } }));

        this.store.dispatch(appDealerDetailActions.LoadCustomViewAction({ payload: { dealerCode: this.sharedDataService.dealerCode, userID: this.sharedDataService.loggedInUserId } }));
        this.store.dispatch(appDealerDetailActions.LoadSalesConsultantAction({ payload: { dealerCode: this.sharedDataService.dealerCode } }));
      }
    });
    this.applyDarkOrLightTheme();
  }
  paymentSimulatorPdfGenerator(data){
    this.paymentSimulatorPdfData = data['printPDFData'];
    this.paymentSimulatorPdfFilename = data['filenameForDownload'];
    this.close();
    const payload = {
      template: this.simulatorPdfViewer,
      data:{
        openModal:true
      },
      style: {
        left: '25%',
        width: '50%',
        height: 'auto',
        top:'10%',
        'background-color': '#FFFFFF',
        'border-radius': '0px',
        position: 'absolute'
      },
      removeOverlay: true
    };
    this._store.dispatch(new WriteupDetailOpenDialog(payload));
  }
  close(){
    this.sharedDataService.closeModal()
  }
  private getPaymentSimulatorMasterData(payload){
    const path = this.environment.MST_BASE_SERVICE_URL + `payment-nexgen/dealers/${this.sharedDataService.dealerCode}/simulator/getVehicleAttributes`;
    return this.http.post(path, payload);
  }

  private  getPlateTransferUIStatus(payload){
    const path = this.environment.MST_BASE_SERVICE_URL + `payment-nexgen/dealers/${this.sharedDataService.dealerCode}/online/tradein/providers`;
    return this.http.post(path, payload);
  }


  applyDarkOrLightTheme(): void {
    this.store.select(fromSelector.getMyTheme).subscribe(theme => {
      if(theme) this.sharedDataService.isDarkTheme = true;
      document.body.setAttribute('data-theme', theme ? 'dark' : 'light');
    });
  }


  reset() {
    this.idle.watch();
    this.isUserTimedOut = false;
  }

  resetSession(event: any) {
    event.dialogRef.close(true);
    event.parent.isUserTimedOut = false;
    event.parent.idle.watch();
    event.parent.refreshToken();
  }

  logout() {
    this.sharedFuncService.logout(window);
  }
  getDealerName(authData) {
    if (authData?.user?.profile) {
      if (!isNil(authData.user.dealerCode) &&
        authData.user.dealerCode.toString() !== '') {
        this.sharedDataService.dealerCode = authData.user.dealerCode;
        const path = this.environment.MST_BASE_SERVICE_URL + `dealers/${this.sharedDataService.dealerCode}/user?criteria=CRMID`;
        this.http.get(path).subscribe(resp=>{
          let response: any = resp;
          this.sharedDataService.salesPersonsData = resp;
          this._store.dispatch(appDealerDetailActions.LoadCrmInfoSuccessAction({response: response}));
        });
      }
      this.loggedInUserName = `${authData.user.profile.given_name} ${authData.user.profile.family_name}`;
      this.sharedDataService.loggedInUserId = authData.user.profile.UserId;
      this.sharedDataService.loggedInUserName = this.loggedInUserName;
      this.sharedDataService.dealerEmail = authData.user.profile.email;
      let data = {
        brandId: 1,
        dealerCode: this.sharedDataService.dealerCode,
        apiKey: this.environment.DIS_API_KEY
      }
      this.store.dispatch(appDealerDetailActions.LoadDealerAction({ payload: data }));

      this.sharedDataService.setRoles(authData.user.profile.roles);
    }
  }

  getDealerPhone(authData) {
    if(authData?.user?.profile) {
      this.sharedDataService.setAndGetValues('dealerPhoneNumberFromToken', true, authData.user.profile.strongAuthenticationPhoneNumber);
    }
  }

  setDealerPersonnelName(authData) {
    if(authData?.user?.profile) {
      this.sharedDataService.setAndGetValues('dealerPersonnelName', true, authData.user.profile.preferred_name);
    }
  }

  setDealerPersonnelFullName(authData) {
    if(authData?.user?.profile) {
      this.sharedDataService.setDealerPersonnelFullNameFromToken(authData.user.profile.given_name, authData.user.profile.family_name);
    }
  }

  setDealerPersonnelEmail(authData) {
    if(authData?.user?.profile) {
      this.sharedDataService.setAndGetValues('dealerPersonnelEmail', true, authData.user.profile.email);
    }
  }
  removeLexusStylesheet(){
    const lexusStylesheet = document.querySelectorAll('[href^="lexus-styles"]')[0];
    const headEl = document.getElementsByTagName('head')[0];
    if(lexusStylesheet) {
      headEl.removeChild(lexusStylesheet);
    }    
  }

  loadTheme() {
    const headEl = document.getElementsByTagName('head')[0];
    const newLinkEl = document.createElement('link');
    newLinkEl.setAttribute('class', 'lexus-theme');
    newLinkEl.rel = "stylesheet";
    newLinkEl.href = "lexus-styles.css";
    headEl.appendChild(newLinkEl);
  }


  ngOnDestroy() {
    window.localStorage.removeItem('cv_queryString')
    this.subs.unsubscribe();
  }
  initializeNavbar(data: models.AuthData) {

    const appNavBar = {
      title: {
        label: getPageDetails(PagesEnum.CutomerDeal).navbarTitle
      },
      menu: {
        name: 'menu',
        onClick: $event => {
        }
      },
      avatar: {
        name: `${data?.user?.profile?.given_name ? data.user.profile.given_name : ''} ${data?.user?.profile?.family_name ? data.user.profile.family_name : ''}`
      },
      notification: {
        name: 'notification'
      },
      messages: {
        name: 'comment'
      },
      style: {}
    };
    this.store.dispatch(AppNavBarSetNavigation({payload:appNavBar}));
  }

  openModal() {
    setTimeout(() => {
      const list = document.getElementsByClassName("cdk-overlay-pane");
      if (list?.length > 0) {
        list[0].remove();
      }
      let list1 = document.getElementsByClassName('cdk-overlay-backdrop');
      while(list1?.length > 0){
        list1[0].remove();
      }
      this.dialogRef = this.matDialog.open(ModalComponent, {
        data: {
          message: { template: this.modalDialog.template, style: this.modalDialog.style },
          buttonText: {
            cancel: 'Done'
          }
        },
        panelClass: 'custom-modalbox',
        disableClose: false
      });
      this.dialogRef.afterOpened().subscribe(() => {
        this.clickoutHandler = this.closeDialogFromClickout;
      });

      this.dialogRef.afterClosed().subscribe(() => {
        this.clickoutHandler = null;
      });
    });
   
  }
     
  closeDialogFromClickout(event: MouseEvent) {
    const rect = document.getElementsByClassName('modal-content')[0]?.getBoundingClientRect();
    if(!isNil(rect)){
    if(event.clientX <= rect.left || event.clientX >= rect.right ||
        event.clientY <= rect.top || event.clientY >= rect.bottom) {
      this.dialogRef.close();
    }
  }
  }
}
